module.exports = __webpack_public_path__ + "static/gallery_01-thumb-bc6cdaa6e8352b25ac08a470efe1b32c.jpg";